export class AdminUpdatePlan {
  name: string

  description?: string

  displayOrder: number

  isActive: boolean

  constructor(data: Partial<AdminUpdatePlan> = {}) {
    this.name = data.name ?? ""

    this.description = data.description

    this.displayOrder = data.displayOrder ?? 0

    this.isActive = data.isActive ?? true
  }
}
